// @ts-check
import { roundToDecimal } from './decimals'
import { isNumber } from './is'
import { cleanUpRound } from './numbers'
const CM_TO_IN = 2.54

const inToCm = inches => cleanUpRound(CM_TO_IN * inches)
const cmToIn = cm => cleanUpRound(cm / CM_TO_IN)

/**
 * This is the the function we always want to use when storing a height/length
 * to the case data.
 *
 * If it is given in inches we'll store it as cm with 2 decimal places of
 * precision to ensure that it is stored with enough precision to be converted
 * back to the same one decimal of precision value if we are going back to inches.
 *
 * @param {number} inches
 * @returns {number}
 */
export const convertInToCmForStorage = inches =>
  roundToDecimal(inToCm(inches), 2)

/**
 * @param {number} heightInCm
 * @param {HeightUnit} targetHeightUnit
 * @returns {number | null}
 */
export const convertStoredCmForDisplay = (heightInCm, targetHeightUnit) => {
  if (!isNumber(heightInCm)) {
    return null
  }
  return roundToDecimal(
    targetHeightUnit === 'in' ? cmToIn(heightInCm) : heightInCm,
    1
  )
}
